import { stateProps } from "../types";

export const checkCurrentFieldStatus = (
  currentStep: number,
  state: stateProps
) => {
  if (currentStep === 1) {
    const { isEmptyTitleField } = state;
    return isEmptyTitleField;
  } else if (currentStep === 2) {
    const { isEmptyFirstName, isEmptyLastName } = state;
    return isEmptyFirstName || isEmptyLastName;
  } else if (currentStep === 3) {
    const { isEmptyGenderField } = state;
    return isEmptyGenderField;
  } else if (currentStep === 4) {
    const { isEmptyAndValidEmail } = state;
    return isEmptyAndValidEmail;
  } else if (currentStep === 5) {
    const { isEmptyPhone } = state;
    return isEmptyPhone;
  } else if (currentStep === 6) {
    const { isEmptyLanguagesField } = state;
    return isEmptyLanguagesField;
  } else if (currentStep === 7) {
    const { isEmptyDegree } = state;
    return isEmptyDegree;
  } else if (currentStep === 8) {
    const { isEmptyQualifications } = state;
    return isEmptyQualifications;
  } else if (currentStep === 9) {
    const { isEmptyPrice } = state;
    return isEmptyPrice;
  } else if (currentStep === 10) {
    const { isEmptyTimeSlotField } = state;
    return isEmptyTimeSlotField;
  } else if (currentStep === 11) {
    const { isEmptyRegiNumber } = state;
    return isEmptyRegiNumber;
  } else if (currentStep === 12) {
    const { isEmptySpeciality } = state;
    return isEmptySpeciality;
  } else if (currentStep === 13) {
    const { isEmptyBoardCertifiedField } = state;
    return isEmptyBoardCertifiedField;
  } else if (currentStep === 14) {
    const { isEmptyPractising } = state;
    return isEmptyPractising;
  } else if (currentStep === 15) {
    const { isEmptyBankName } = state;
    return isEmptyBankName;
  } else if (currentStep === 16) {
    const { isEmptyBranchName } = state;
    return isEmptyBranchName;
  } else if (currentStep === 17) {
    const { isEmptyAcntHolder } = state;
    return isEmptyAcntHolder;
  } else if (currentStep === 18) {
    const { isEmptyAcntNumber } = state;
    return isEmptyAcntNumber;
  } else if (currentStep === 19) {
    const { isEmptySignatureImageField } = state;
    return isEmptySignatureImageField;
  } else if (currentStep === 20) {
    const { isEmptyProfileImageField } = state;
    return isEmptyProfileImageField;
  } else if (currentStep === 21) {
    const { isEmptyNicImageField } = state;
    return isEmptyNicImageField;
  } else if (currentStep === 22) {
    const { isEmptySealImageField } = state;
    return isEmptySealImageField;
  } else if (currentStep === 23) {
    const { isEmptySlmcCertificateImageField } = state;
    return isEmptySlmcCertificateImageField;
  } else if (currentStep === 24) {
    const { isEmptySlmcIDImageField } = state;
    return isEmptySlmcIDImageField;
  } else if (currentStep === 25) {
    const { isEmptyProofOfQualificationImageField } = state;
    return isEmptyProofOfQualificationImageField;
  } else if (currentStep === 26) {
    const { isEmptyTermsAndConditionsField } = state;
    return isEmptyTermsAndConditionsField;
  }
};
